import { render, staticRenderFns } from "./ShowBatchWoTpResult.vue?vue&type=template&id=2b1e7856&scoped=true&"
import script from "./ShowBatchWoTpResult.vue?vue&type=script&lang=js&"
export * from "./ShowBatchWoTpResult.vue?vue&type=script&lang=js&"
import style0 from "./ShowBatchWoTpResult.vue?vue&type=style&index=0&id=2b1e7856&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b1e7856",
  null
  
)

export default component.exports